import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { ConfirmAlert } from 'modules/common/components/Alert';
import BusinessAssignModal from '../modals/BusinessAssignModal';
import * as actions from '../action';

function TaxPayer({
  taxPayer,
  newBusinessesInfo,
  ordinanceRevisionId,
  removeUser,
  getSingleNewBusinesses,
  newBusinessesId,
}) {
  const permissions = getJson('permissions');
  const setModal = useContext(ModalContext);
  const businessId = _.get(newBusinessesInfo, 'id');

  const handleBusinessAssign = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <BusinessAssignModal
          updateList={_.get(newBusinessesInfo, 'attributes')}
          id={+businessId}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Business Assign',
      modalSize: 'modal-lg',
    });
  };

  const handleRemoveUser = () => {
    ConfirmAlert(
      'Are you sure, you want to remove this user?',
      () => {
        removeUser(newBusinessesId, {}, () => {
          getSingleNewBusinesses(newBusinessesId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="col-12 d-flex justify-content-end">
          {Acl(permissions, ['BPLS BUSINESS ASSIGN']) && (
            <button
              onClick={handleBusinessAssign}
              type="button"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary mb-2"
            >
              {!_.isEmpty(taxPayer) ? 'Re Assign' : 'Assign'}
            </button>
          )}

          {/* {Acl(permissions, ['BPLS BUSINESS UNASSIGN']) && ( */}
          <button
            onClick={() => handleRemoveUser()}
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary mb-2 ml-2"
          >
            Remove User
          </button>
          {/* )} */}
        </div>
        {!_.isEmpty(taxPayer) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm ">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="250">
                          Name
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(taxPayer, 'first_name')}{' '}
                            {_.get(taxPayer, 'middle_name')}{' '}
                            {_.get(taxPayer, 'last_name')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Sex
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'gender')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Civil Status
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'civil_status')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Birth Date
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'birth_date')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Address
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(taxPayer, 'street')},{' '}
                            {_.get(taxPayer, 'barangay_name')},{' '}
                            {_.get(taxPayer, 'municipality_name')},{' '}
                            {_.get(taxPayer, 'province_name')},{' '}
                            {_.get(taxPayer, 'region_name')}{' '}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Email
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'email')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          GSIS ID Number
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'gsis_id_number')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          SSS ID Number
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'sss_id_number')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          PAGIBIG ID Number
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'pagibig_id_number')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Philhealth ID Number
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'philhealth_id_number')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Tax Identification Number
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'tin_number')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Mobile Number
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'mobile_number')}</b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Telephone Number
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>{_.get(taxPayer, 'telephone_number')}</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

TaxPayer.defaultProps = {
  taxPayer: {},
};

TaxPayer.propTypes = {
  taxPayer: PropTypes.instanceOf(Object),
  newBusinessesInfo: PropTypes.instanceOf(Object).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  removeUser: PropTypes.instanceOf(Function).isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  newBusinessesId: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaxPayer);
